import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isEqual, each, includes } from 'lodash-es';
import cx from 'classnames';

import AddToListButton from './AddToListButton';
import ListsModal from './ListsModal';
import listConfig, { MARKET_LIST_TYPE, KEYWORD_LIST_TYPE } from './listTypeConfig';

const token = document.getElementsByName('user_token')[0]
  ? document.getElementsByName('user_token')[0].getAttribute('content')
  : '';

const AddToList = (props) => {
  const {
    listType,
    disabled,
    buttonSize,
    buttonText,
    className,
    clickCallback,
    clickCloseCallback,
    customerId,
    currentUserId,
    store,
    defaultSelectedStore,
    variant,
    icon,
    withoutIcon,
  } = props;
  const [modalOpened, setModalOpened] = useState(false);
  const [entities, setEntities] = useState(props.entities);
  const [updatedList, setUpdatedList] = useState({});
  const [websocketSub, setWebsocketSub] = useState(null);
  const customer_id = customerId;

  useEffect(() => {
    if (token?.length > 0 && customer_id && !websocketSub) {
      App.initCable(token);
      const sub = App.cable.subscriptions.create(
        { channel: listConfig[listType].websocketChannel, customer_id },
        {
          received: (event) => {
            setUpdatedList({});
            setTimeout(() => setUpdatedList(event), 500);
          },
        }
      );
      setWebsocketSub(sub);
    }

    return () => {
      if (App.cable) {
        each(App.cable.subscriptions.subscriptions, (sub) => {
          if (includes(sub.identifier, listConfig[listType].websocketChannel)) {
            App.cable.subscriptions.remove(sub);
          }
        });
      }
    };
  }, [listType]);

  useEffect(() => {
    if (!isEqual(props.entities, entities)) {
      setEntities(props.entities);
    }
  }, [props.entities]);

  const handleModalOpen = useCallback(() => {
    setModalOpened(true);
    setUpdatedList({});
  }, []);

  useEffect(() => {
    if (clickCallback && modalOpened) {
      clickCallback();
    }
  }, [modalOpened]);

  const handleModalClose = useCallback(() => {
    setModalOpened(false);
    setUpdatedList({});
    if (clickCloseCallback) {
      clickCloseCallback();
    }
    const closeEvent = new CustomEvent('close-modal');
    document.dispatchEvent(closeEvent);
  }, []);

  return (
    <div className={cx('d-flex align-items-center', className)} style={{ whiteSpace: 'normal' }}>
      <AddToListButton
        disabled={disabled || isEmpty(entities)}
        buttonText={buttonText}
        size={buttonSize}
        variant={variant}
        icon={icon}
        withoutIcon={withoutIcon}
        onOpen={handleModalOpen}
      />
      {!disabled && modalOpened && (
        <ListsModal
          opened={modalOpened}
          entities={entities}
          listType={listType}
          currentStore={store}
          defaultSelectedStore={defaultSelectedStore}
          updatedListName={
            !isEmpty(updatedList) && parseInt(currentUserId, 10) !== updatedList.current_user_id
              ? updatedList.list.name
              : ''
          }
          onClose={handleModalClose}
        />
      )}
    </div>
  );
};

AddToList.propTypes = {
  disabled: PropTypes.bool,
  buttonSize: PropTypes.string,
  entities: PropTypes.array,
  buttonText: PropTypes.string,
  className: PropTypes.string,
  store: PropTypes.string,
  defaultSelectedStore: PropTypes.string,
  clickCallback: PropTypes.func,
  clickCloseCallback: PropTypes.func,
  listType: PropTypes.oneOf([MARKET_LIST_TYPE, KEYWORD_LIST_TYPE]).isRequired,
  customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.string,
  icon: PropTypes.string,
  withoutIcon: PropTypes.bool,
};

AddToList.defaultProps = {
  disabled: false,
  buttonText: '',
  entities: [],
  store: null,
  defaultSelectedStore: null,
};

export default AddToList;
